const deleteChecklistBySiteStr = {
  toastr: 'O checklist foi apagado!'
};

export default deleteChecklistBySiteStr;
